
import { defineComponent, onMounted } from 'vue';
import DriveMain from '@/modules/drive/view-models/DriveMain.vue';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: {
    DriveMain,
  },
  setup() {
    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {};
  },
});
